import styles from "../Merging.module.css";
import React, {forwardRef, useImperativeHandle} from "react";
import classes from "../KeywordsMergingDisplay/KeywordsMergingDisplay.module.css";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import DroppableList from "../DraggingWrappers/DroppableList";


const AuthorsMergingDisplay = forwardRef(({toPattern, fromPattern}, ref) => {
    const from = fromPattern && fromPattern.authors.map(item => ({...item, newAuthor: true}))
    const bothList = toPattern && fromPattern ? [...toPattern.authors, ...from] : [];

    const uniqueList = bothList.filter((item, index, self) =>
        index === self.findIndex((i) => i.user_id === item.user_id)
    );

    useImperativeHandle(ref, () => ({
        getList: () => {
            return uniqueList;  // Return the current state of toList
        }
    }));

    const toArr =
        uniqueList.map(author => (
            {
                id: 'author for to pattern' + author.user_id,
                content: <OverlayTrigger
                    key={author.user_id + 'toListUsersOverlay'}
                    trigger={["click"]}
                    rootClose
                    placement="bottom"
                    overlay={
                        <Popover id="pattern-game-description">
                            <Popover.Title>Authors Cannot Be Removed</Popover.Title>
                            <Popover.Content className="game-description">
                                When Merging Patterns the "Merged From" pattern's authors automatically become authors
                                of your
                                pattern.
                            </Popover.Content>
                        </Popover>
                    }>
                    <div
                        key={author.user_id + 'toListUsers'}
                        className={`${author.newAuthor ? `${classes.Keyword} ${classes.GrayedOut}` : classes.ToKeyWord} clickable`}
                        onClick={() => {
                        }}
                    >
                        {author.display_name}
                    </div>
                </OverlayTrigger>,
                disableDrag: true
            }
        ))

    const fromArr = (fromPattern && fromPattern.authors.map(author => (
        {
            id: 'author for from pattern' + author.user_id,
            content: <div
                key={author.user_id + 'fromListUsers'}
                className={`${classes.Keyword} clickable ${classes.GrayedOut}`}
                onClick={() => {
                }}
            >
                {author.display_name}
            </div>,
            disableDrag: true
        }
    ))) || []

    return <div className={styles.Container}>
        <div className={styles.SplitCols}>
            <h3>Authors:</h3>
            <DroppableList list={toArr} targetListName='toList' itemType={"AUTHORS"}/>
        </div>
        <div className={styles.Separator}></div>
        <div className={styles.SplitCols}>
            <h3>Authors:</h3>
            <DroppableList list={fromArr} targetListName='fromList' itemType={"AUTHORS"}/>
        </div>
    </div>
});

export default AuthorsMergingDisplay